export default class Map {

  constructor(id, defaultPostcode, overlay) {
    this.container = document.getElementById(id);

    if (this.container == null) return;

    this.overlay = overlay;
    this.marker;
    this.googleMap = this.overlay.getMap();

    // Find all map items/cities
    this.mapItems = this.container.querySelectorAll('.map-item');
    this.mapSelect = this.container.querySelector('.map-select');
    this.mapList = this.container.querySelector('.map-list');
    this.mapInstallers = this.container.querySelectorAll('.map-installers');
    this.searchForm = this.container.querySelector('#searchForm');
    // Selected item class name
    this.mapItemSelected = 'selected';

    this.pinIcon == {
      url: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIzNHB4IiB2aWV3Qm94PSIwIDAgMjQgMzQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU0LjEgKDc2NDkwKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5pYy1sb2NhdGlvbjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJNb2JpbGUiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJMYW5kaW5nLU1vYmlsZS1BIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjY1LjAwMDAwMCwgLTQ0OTEuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJpYy1sb2NhdGlvbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjU3LjAwMDAwMCwgNDQ4OC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMCwzLjMzMzMzMzMzIEMxMy41NSwzLjMzMzMzMzMzIDguMzMzMzMzMzMsOC41NSA4LjMzMzMzMzMzLDE1IEM4LjMzMzMzMzMzLDIzLjc1IDIwLDM2LjY2NjY2NjcgMjAsMzYuNjY2NjY2NyBDMjAsMzYuNjY2NjY2NyAzMS42NjY2NjY3LDIzLjc1IDMxLjY2NjY2NjcsMTUgQzMxLjY2NjY2NjcsOC41NSAyNi40NSwzLjMzMzMzMzMzIDIwLDMuMzMzMzMzMzMgWiBNMjAsMTkuMTY2NjY2NyBDMTcuNywxOS4xNjY2NjY3IDE1LjgzMzMzMzMsMTcuMyAxNS44MzMzMzMzLDE1IEMxNS44MzMzMzMzLDEyLjcgMTcuNywxMC44MzMzMzMzIDIwLDEwLjgzMzMzMzMgQzIyLjMsMTAuODMzMzMzMyAyNC4xNjY2NjY3LDEyLjcgMjQuMTY2NjY2NywxNSBDMjQuMTY2NjY2NywxNy4zIDIyLjMsMTkuMTY2NjY2NyAyMCwxOS4xNjY2NjY3IFoiIGlkPSJTaGFwZSIgZmlsbD0iI0UxMEY0OCIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iUGF0aCIgcG9pbnRzPSIwIDAgNDAgMCA0MCA0MCAwIDQwIj48L3BvbHlnb24+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==',
      scaledSize: new google.maps.Size(100, 100),
  }
    this.mapListPadding();

    // Attach event listeners to map items
    this.mapItems.forEach((element) => {
      element.addEventListener('click', this.selectItem.bind(this, element));
    })

    // Select form input for switching cities
    // this.mapSelect.addEventListener('change', this.selectItem.bind(this, event));

    // On load select city by default
    const defaultCity = document.querySelector(`[data-postcode="${defaultPostcode}"]`);
    if (defaultCity) {
      this.selectItem(document.querySelector(`[data-postcode="${defaultPostcode}"]`));
    }

    // Postcode search button
    this.searchForm.addEventListener('submit', (event) => {
      this.search(event);
    });

    // Passive resize event listener
    window.addEventListener('resize', this.onScreenResize.bind(this), {passive: true});
  }

  /**
   * Handler for screen resizes
   *
   * We reselect the item and realign it to the center (for when it switches from mobile to desktop)
   */
  onScreenResize() {
    // Reselect the selected item as we have to maybe change the scroll position
    const selectedItem = this.container.querySelector('[data-postcode].selected');

    if (selectedItem) {
      this.selectItem(selectedItem);
    }

    this.mapListPadding();
  }

  /**
   * The argument can be either an event or the element itself
   *
   * Selects a map item/city
   * Adds the selected class and scrolls the item to the center of the list
   * Also selects the option in the select field
   */
  selectItem(element) {
    // Remove the selected class from all items/cities
    this.mapItems.forEach((item) => {
      if (item.classList.contains(this.mapItemSelected)) {
        item.classList.remove(this.mapItemSelected)
      }
    })

    let postcode;
    let city;
    let item = element;

    if (element instanceof Event) {
      postcode = this.mapSelect.options[this.mapSelect.selectedIndex].value;

      // Lets fetch the element we want to select for desktop
      item = this.container.querySelector(`[data-postcode="${postcode}"`);
    } else {
      if (! element.hasAttribute('data-postcode')) return;

      postcode = element.getAttribute('data-postcode');
      city = element.getAttribute('data-city');

      // select city in select box
      // var options = this.mapSelect.options;
      // for (let i = 0; i < options.length; i++) {
      //   if (options[i].value == postcode) {
      //     this.mapSelect.selectedIndex = i;
      //     break;
      //   }
      // }
    }

    // select the postcode on the Google map
    //this.placePin(postcode + ' Denmark');
    this.placePin(postcode + ' ' + city);
    this.showCity(postcode);

    // Select the item in the list and scroll offset
    item.classList.add(this.mapItemSelected)
    this.mapList.scrollTop = item.offsetTop - this.mapList.clientHeight / 2;

    // show the items of this city
  }

  /**
   * Sets the top padding on the map list,
   * so the top / bottom entries end at the middle
   */
  mapListPadding() {
    if (this.mapList) {
      let height = this.mapList.clientHeight / 2;
      this.mapList.childNodes[1].style.paddingTop = height + 'px';
      this.mapList.childNodes[1].style.paddingBottom = height + 'px';
    }
  }

  /**
   * Places the pin of the given address on the map
   * Before placing the pin it clears the current one
   *
   * @param {string} address Street address
   */
  placePin(address) {
    if (this.marker != null) {
      this.marker.setMap(null);
    }

    let geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      {
        'address': address
      }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          this.marker = new google.maps.Marker({
            map: this.googleMap,
            position: results[0].geometry.location,
            optimized: false,
            icon: this.pinIcon

          });
        } else {
          console.log('Geocode was not successful for the following reason: ' + status);
        }
    });
  }

  /**
   * Show the list of installers in the selected city
   *
   * This is the secondary list with the names, phone number
   * and address.
   *
   * @param {int} postcode
   */
  showCity(postcode) {
    // Hide all
    this.mapInstallers.forEach((item) => {
      if (! item.classList.contains('hidden')) {
        item.classList.add('hidden')
      }
    })

    // Show selected
    let installers = this.container.querySelector(`#installers${postcode}`);
    installers.classList.remove('hidden');
  }

  /**
   * Searches for the city with the specified postcode
   *
   * @param {Event} event
   */
  search(event) {
    event.preventDefault();
    // @TODO: Remove error state from input field
    const postcode = this.container.querySelector('#searchPostcode').value;
    let found = false;

    // loop through all cities and select the one
    this.mapItems.forEach((item) => {
      if (item.getAttribute('data-postcode') == postcode && !found) {
        this.selectItem(item);
        found = true;
      }
    })

    // @TODO: if not found, show error state on input field
  }

}
